import React from 'react';
import { Image, Stack } from 'react-bootstrap';
import { IMAGE_PATHS } from 'constants/imagePaths';
import moment from 'moment';
import parse from 'html-react-parser';
import { useNavigate } from 'react-router-dom';

export const Blog: React.FC<any> = ({ blog }) => {
	const navigate = useNavigate();
	const {
		id,
		attributes: {
			Title: title,
			publishedAt,
			Description: description,
			Image: imageList,
			category: categoryList,
		},
	} = blog;

	const image = imageList?.data
		? {
				id: imageList?.data?.id,
				attributes: {
					name: imageList?.data?.attributes?.name,
					hash: imageList?.data?.attributes?.hash,
					url: imageList?.data?.attributes?.formats?.medium?.url,
				},
			}
		: null;

	const { attributes: category = {} } = categoryList?.data || [];

	return (
		<div className="blog-card" onClick={() => navigate(`/blogs/${id}`)}>
			<div className="blog-card-img mb-3 mb-md-4">
				<Image
					src={image?.attributes?.url ? image?.attributes?.url : IMAGE_PATHS.UserDefault}
					alt="blog-img"
					className="w-100 h-100 object-fit-cover"
					loading="lazy"
				/>
			</div>
			<Stack className="blog-card-content">
				{publishedAt && (
					<h6 className="fw-bold mb-0">{moment(publishedAt).format('D MMM YYYY')}</h6>
				)}
				<div className="d-flex align-items-center gap-3">
					<h5 className="fw-bold mb-0 flex-1">{title}</h5>
					<i className="ri-arrow-right-up-line fw-bold"></i>
				</div>
				{description && <p className="mb-0">{parse(description)}</p>}
				{category?.Name && (
					<div className="blog-info d-flex flex-wrap gap-2">
						<div className="blog-info-box">{category.Name}</div>
					</div>
				)}
			</Stack>
		</div>
	);
};

export default Blog;
